module.exports = __webpack_public_path__ + "static/media/unknown.44b2929d.png";